import { Outlet, ScrollRestoration } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import {
  ToastProviderX,
  WindowDimensionsProvider,
} from "@songtradr-one/components-frontend";
import { ToastProvider } from "@songtradr/component-library";
import { AppContextProvider } from "../context/app-context/AppContext";
import { ModalConfirmProvider } from "../context/modal-confirm-context/ModalConfirmContext";
import { getApollo } from "../helpers/get-apollo";
import { Props } from "./App.Parts";

export const App = ({ config }: Props) => {
  const { client } = getApollo();

  return (
    <WindowDimensionsProvider>
      <ToastProviderX>
        <ToastProvider>
          <ApolloProvider client={client}>
            <AppContextProvider appConfig={config}>
              <ModalConfirmProvider>
                <ScrollRestoration />
                <Outlet />
              </ModalConfirmProvider>
            </AppContextProvider>
          </ApolloProvider>
        </ToastProvider>
      </ToastProviderX>
    </WindowDimensionsProvider>
  );
};
